module.exports = __webpack_public_path__ + "img/sand-decal-13.5f6780a0.png";